<template>
 <div id="page-wrap" v-if="loggedIn">
   <PageHeader></PageHeader>
   <div class="container settledTxnDetails content-wrap">
     <div class="row">
       <div class="hidden-xs col-md-10 col-md-offset-1">
          <QuickLinks ></QuickLinks>
       </div>
        <ProfileContent class="hidden-xs hidden-sm" :device="'desktop'" :nav="'reward-points'"></ProfileContent>
        <section class="col-md-7">
          <div class="content-section">
            <PointsStatement ></PointsStatement>
          </div>
        </section>

        <MobileNav :activeLink="'reward-points'" class="visible-xs"></MobileNav>
     </div>
   </div>
 </div>
</template>

<script>
import PageHeader from './PageHeader/index'
//import SettledTransactions from './SettledTransactions/index'
import ProfileContent from './ProfileContent/index'
import PointsStatement from './PointsStatement/index'
//import TransactionsDetail from './TransactionsDetail/index'
import QuickLinks from './QuickLinks/index'
import MobileNav from './MobileNav/index'
import {mapGetters} from 'vuex'

export default {
  name: 'RewardPoints',
  data () {
    return {
    }
  },
  components: { PageHeader, PointsStatement, ProfileContent, QuickLinks, MobileNav },
  computed:{
    ...mapGetters([
      "loggedIn"
    ])
  },
  mounted () {

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../assets/sass/variables';
  .content-section{
    min-height: 500px;
    background: var(--white);
  }
  @media screen and (max-width:$sm){
    .settledTxnDetails header{
      margin: 0 -15px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/RewardPoints.vue